var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
import React from 'react';
import { Spinner, SpinnerSize } from '@fluentui/react';
const LoaderComponent = ({ primaryText }) => {
    return (React.createElement(React.Fragment, null, primaryText && primaryText !== '' && (React.createElement(React.Fragment, null,
        React.createElement("div", { style: {
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                zIndex: 1000001,
            } }),
        React.createElement("div", { style: {
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 1000000,
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                padding: '20px',
                borderRadius: '8px',
                boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.5)',
            } },
            React.createElement(Spinner, { "data-testid": "spinner", size: SpinnerSize.large, label: primaryText || 'Loading...' }))))));
};
export default LoaderComponent;
//# sourceMappingURL=LoaderComponent.js.map